import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import styled, { css } from "styled-components";

const StyledReactTable = styled(ReactTable as any)<{ $noHover?: boolean }>`
  .rt-thead.-header {
    position: sticky;
    top: 0;
    z-index: var(--z-sticky, 200);
    background: var(--Primary-Color-Shade-1-pale);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .rt-thead .rt-th {
    min-height: 44px;
    display: flex;
    align-items: center;
    border-right: 1px solid #e5e7eb;
  }

  ${({ $noHover }) =>
    !$noHover &&
    css`
      .rt-tr-group:hover .rt-tr {
        background: #f7f8f8;
        transition: background var(--transition-xs, 0.2s) ease;
      }

      .rt-tr.-odd:hover .rt-tr,
      .rt-tr.-even:hover .rt-tr {
        background: #f7f8f8;
      }
    `}

  .rt-tbody .rt-tr {
    transition: background var(--transition-xs, 0.2s) ease;
  }
`;

interface IProps {
  list: any[];
  columns: any[];
  className?: string;
  noHover?: boolean;
  [key: string]: any;
}
const CustomTable: React.FunctionComponent<IProps> = ({
  list,
  columns,
  className,
  noHover,
  ...rest
}) => {
  const arr = list || [];
  return (
    <StyledReactTable
      data={arr}
      showPageSizeOptions={false}
      showPagination={false}
      pageSize={Array.isArray(arr) ? arr.length : 30}
      className={className ? `${className} -striped` : "-striped"}
      columns={columns}
      $noHover={noHover}
      {...rest}
    />
  );
};

export default CustomTable;
